export default __webpack_public_path__ + "static/media/womens_diamond_band.a33929ba.png";